const groupPrefix = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.MEALPREPS)

export const apiMealpreps = {
	fetchDietMealpreps: async (search: string | undefined, page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IDietMealprep[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { name: search }),
		})
		return { data: data.map(d => DietMealprep(d)), meta }
	},

	editDietMealpreps: async (name: string) => {
		const { data } = await apiCommon<IDietMealprep>(`${groupPrefix}`, {
			method: 'PUT',
			body: dietMealprepToJSON({ name }),
		})
		return DietMealprep(data)
	},
}
